import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "@/App";

// Sentry: opt-in via REACT_APP_SENTRY_DSN. Without the env var set, the dynamic import is
// skipped so dev builds don't pay the SDK download cost. Wrapped so a missing/broken SDK
// never blocks the app from booting.
const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
if (sentryDsn) {
  import("@sentry/react")
    .then((Sentry) => {
      Sentry.init({
        dsn: sentryDsn,
        environment: process.env.REACT_APP_SENTRY_ENV || "production",
        tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.1"),
        // Don't ship browser PII by default.
        sendDefaultPii: false,
      });
    })
    .catch(() => {
      // Sentry SDK failed to load — log only; never crash the app over telemetry.
      console.warn("Sentry SDK failed to load");
    });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
